import "./AboutFETC.module.css";
import Header from "@/reusable_sections/Header";
import OurCorporateIdentity from "./sections/OurCorporateIdentity";
import TwentyFiveYearsOfExpertExperience from "./sections/TwentyFiveYearsOfExpertExperience";
import Footer from "@/reusable_sections/Footer";
export default function AboutFETCPage() {
  return <div>
      <Header />
      <OurCorporateIdentity />
      <TwentyFiveYearsOfExpertExperience />
      <Footer />
    </div>;
}